import {
  EColor,
  EColorName,
  EMetal,
  PaperLeftyBorderedColorHandler,
  PaperLeftyBorderedColorProps,
} from '@core/type';

import { getPaletteHandlers } from './palette';

const GOLD_GRADIENT_DEG = 176;
const DEFAULT_GRADIENT_DEG = 169;

const getLinearGradient = (
  startColor: EColorName,
  endColor: EColorName,
  deg = DEFAULT_GRADIENT_DEG,
): Pick<PaperLeftyBorderedColorProps, 'backgroundImage'> => ({
  backgroundImage: `linear-gradient(${deg}deg, ${startColor}, ${endColor} )`,
});

export const getPaperLeftyBorderedColorProps: PaperLeftyBorderedColorHandler = ({
  palette,
  color,
}) => {
  const { getColor, getBackgroundColor } = getPaletteHandlers(palette);

  if (color === EMetal.GOLD) {
    return getLinearGradient(
      getColor({ commonType: EColor.YELLOW, intensity: EColor.R400 }),
      getColor({ commonType: EColor.RED, intensity: EColor.R300 }),
      GOLD_GRADIENT_DEG,
    );
  }

  if (color === EMetal.SILVER) {
    return getLinearGradient(
      getColor({ commonType: EColor.GRAY, intensity: EColor.R200 }),
      getColor({ commonType: EColor.PURPLE, intensity: EColor.R400 }),
    );
  }

  if (color === EMetal.PLATINUM) {
    return getLinearGradient(
      getColor({ commonType: EColor.GREEN, intensity: EColor.R300 }),
      getColor({ commonType: EColor.PURPLE, intensity: EColor.R500 }),
    );
  }

  if (color === EMetal.PALLADIUM) {
    return getLinearGradient(
      getColor({ commonType: EColor.BLUE, intensity: EColor.A200 }),
      getColor({ commonType: EColor.PURPLE, intensity: EColor.R600 }),
    );
  }

  return { backgroundColor: getBackgroundColor(EColor.NEUTRAL) };
};
